import React from 'react';
import { observer } from 'mobx-react';
import { linearModel } from 'mobx-store';

import AlphaSliderComponent from './Component';

const AlphaSliderContainer = observer(
  class AlphaSliderContainer extends React.Component {
    constructor (props) {
      super(props);

      this.handleChange = confidenceInterval => {
        linearModel.confidenceInterval = confidenceInterval;
      };
    }

    render () {
      return (
        <AlphaSliderComponent
          onChange={this.handleChange}
          value={linearModel.confidenceInterval}
        />
      );
    }
  }
);

export default AlphaSliderContainer;
